import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { steps, mockupImage } from '../data/content';
export function HowItWorks() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="how-heading" data-id="element-94" data-mp="3pyroqzddcubm">
      <div className="mx-auto max-w-6xl px-5" data-id="element-95" data-mp="3q0uo4a0evzt0">
        <div id="how-heading" data-id="element-96" data-mp="3u14rrg0qee4p">
          <SectionHeading eyebrow="How it works" title="Go from digital download to playtime in just minutes" data-id="element-97" data-mp="3u0d5ivt0xsr3" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mx-auto mt-8 max-w-3xl overflow-hidden rounded-4xl border-4 border-blush-100 shadow-card" data-id="element-98" data-mp="qibi3eb2q9ft">
          <img src={mockupImage} alt="A girl cutting out freshly printed paper dolls at a table next to a home printer, paper rooms and a dollhouse" className="h-full w-full object-cover" loading="lazy" data-id="element-99" data-mp="14huq873vxks4" />
        </motion.div>

        <ol className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-100" data-mp="2mo5xwc0avi20">
          {steps.map((step, index) => <motion.li key={step.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.45,
          delay: index * 0.1
        }} className="relative rounded-3xl bg-cream p-7 text-center" data-id="element-101" data-mp="31d24e4mpkn0i" data-mpi={index}>
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blush-500 font-display text-xl font-bold text-white" data-id="element-102" data-mp="3kav7p818uyyf">
                {step.number}
              </span>
              <h3 className="mt-4 font-display text-xl font-bold text-ink" data-id="element-103" data-mp="1pvsn9or1y72d">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-104" data-mp="1kxhc9ap0tqik">{step.text}</p>
            </motion.li>)}
        </ol>

        <div className="mt-12 rounded-4xl border-2 border-dashed border-lilac-200 bg-lilac-100/50 p-7 text-center sm:p-10" data-id="element-105" data-mp="3l0sak4hzgc16">
          <p className="mx-auto max-w-3xl font-display text-lg leading-relaxed text-ink sm:text-xl" data-id="element-106" data-mp="3pytsun7l47bl">
            There was a time when a simple piece of paper could become an entire world for a
            child. With screens everywhere today, it&apos;s easy for creative play to get pushed
            aside. Hands-on activities give kids a chance to imagine, create, make choices and
            enjoy meaningful play away from the screen.
          </p>
        </div>
      </div>
    </section>;
}